import "../node_modules/jquery/dist/jquery.js";
import "../node_modules/foundation-sites/dist/js/foundation.js";
import "../node_modules/motion-ui/dist/motion-ui.js";
import "../node_modules/leaflet/dist/leaflet.js";

/* jQuery */
import "./_jquery-fix.js";
import "./vendor/velocity.js";
import "./vendor/velocity.ui.js";
import { fnotify } from "./shared/_foundationNotify.js";
import "../node_modules/corejs-typeahead/dist/typeahead.jquery.js";
// import "../node_modules/corejs-typeahead/dist/bloodhound.js";
import "../node_modules/stupid-table-plugin/stupidtable.js";
import "../node_modules/jquery-contextmenu/dist/jquery.contextMenu.js";
import "../node_modules/jquery-contextmenu/dist/jquery.ui.position.js";

// Then export rest.
globalThis.Bloodhound = require("corejs-typeahead/dist/bloodhound.min");
globalThis.fnotify = fnotify;

/* app global aufbauen */
let app = window.app || {};
app.data = {
  encrypted: {},
  missions: {},
  lastUpdate: {},
  users: {},
  customers: {}
};
